import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Button,
  Box,
  InputAdornment,
  IconButton,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { StyledTextField } from './StyledTextField';

function PasswordChangeForm({ onSave }) {
  const [passwordData, setPasswordData] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [showPasswords, setShowPasswords] = useState({ new: false, confirm: false });

  const handlePasswordChange = (e) => {
    setPasswordData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const toggleShowPassword = (field) => {
    setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = () => {
    onSave({
      newPassword: passwordData.newPassword,
      confirmPassword: passwordData.confirmPassword,
      resetForm: () => {
        setPasswordData({ newPassword: '', confirmPassword: '' });
      },
    });
  };

  const handleClear = () => {
    setPasswordData({ newPassword: '', confirmPassword: '' });
  };

  return (
    <Card sx={{ bgcolor: '#2C2C2F', borderRadius: 3 }}>
      <CardHeader title="Alterar Senha" sx={{ borderBottom: '1px solid #444' }} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <StyledTextField
              fullWidth
              label="Nova Senha"
              name="newPassword"
              type={showPasswords.new ? 'text' : 'password'}
              value={passwordData.newPassword}
              onChange={handlePasswordChange}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => toggleShowPassword('new')}
                      edge="end"
                      sx={{ color: '#9e9e9e' }}
                    >
                      {showPasswords.new ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <StyledTextField
              fullWidth
              label="Confirmar Senha"
              name="confirmPassword"
              type={showPasswords.confirm ? 'text' : 'password'}
              value={passwordData.confirmPassword}
              onChange={handlePasswordChange}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => toggleShowPassword('confirm')}
                      edge="end"
                      sx={{ color: '#9e9e9e' }}
                    >
                      {showPasswords.confirm ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button variant="contained" onClick={handleSubmit} color="primary">
            Alterar Senha
          </Button>
          <Button
            variant="outlined"
            onClick={handleClear}
            sx={{
              borderColor: '#777',
              color: '#e0e0e0',
              '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.08)' },
            }}
          >
            Limpar
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default PasswordChangeForm;
